module.exports = __webpack_public_path__ + "assets/img/logo-auc.fbc5aac0.png";